import { Button, Card } from '@payaca/ambrosia';
import { FC } from 'react';

import { PipelineGuardSimpleConditionType } from '@/gql/graphql';

import UntitledIcon from '@payaca/untitled-icons';
import { v4 as uuid } from 'uuid';

import {
  PipelineGuardAnd,
  PipelineGuardAndChild,
} from '../../types/pipelineGuardTypes';
import GuardConditionRow from './GuardConditionRow';

export type {
  PipelineGuardAnd,
  PipelineGuardAndChild,
  PipelineGuardNot,
  PipelineGuardProjectHasTag,
  PipelineGuardSimple,
} from '../../types/pipelineGuardTypes';

type Props = {
  value: PipelineGuardAnd;
  onChange: (guard: PipelineGuardAnd | null) => void;
};

const DEFAULT_CONDITION_TYPE: PipelineGuardSimpleConditionType =
  'PROJECT_HAS_ACCEPTED_PROPOSAL';

const PipelineGuardAndFieldset: FC<Props> = (props) => {
  const { value, onChange } = props;

  const handleConditionChange = (
    index: number,
    newChild: PipelineGuardAndChild
  ) => {
    const newChildren = [...value.children];
    newChildren[index] = newChild;

    onChange({ ...value, children: newChildren });
  };

  const handleAddChild = () => {
    onChange({
      ...value,
      children: [
        ...value.children,
        {
          type: 'simple',
          conditionType: DEFAULT_CONDITION_TYPE,
          tempIdentifier: uuid(),
        },
      ],
    });
  };

  const handleRemoveChild = (index: number) => {
    if (value.children.length === 1) {
      // if removing the last child, remove whole guard
      onChange(null);
      return;
    }

    onChange({
      ...value,
      children: value.children.filter((_, i) => i !== index),
    });
  };

  return (
    <Card sizeVariant="sm">
      <Card.Body className="flex flex-col gap-2.5 w-full items-start">
        {value.children.map((child, index) => {
          return (
            <div
              key={child.tempIdentifier}
              className="flex flex-col gap-2 w-full origin-top"
            >
              {index !== 0 && <p>and</p>}
              <GuardConditionRow
                value={child}
                onSubmit={(newChild) => handleConditionChange(index, newChild)}
                onRemove={() => handleRemoveChild(index)}
              />
            </div>
          );
        })}
        <Button
          variant="link"
          linkColour="dark"
          size="xs"
          className="font-normal"
          onClick={handleAddChild}
        >
          <UntitledIcon className="h-4 w-4" name="plus-circle.3" />
          and
        </Button>
      </Card.Body>
    </Card>
  );
};

export default PipelineGuardAndFieldset;
